<template>
  <div data-app>
    <v-dialog
      content-class="loading-spinner-dialog__wrapper"
      persistent
      :value="isOpen"
    >
      <div class="spinner__wrapper">
        <v-progress-circular indeterminate color="#0cb3e4" size="48">
        </v-progress-circular>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: ['isOpen']
};
</script>

<style lang="scss">
.loading-spinner-dialog__wrapper {
  box-shadow: none !important;
}
</style>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints.scss';

.spinner__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}
</style>
